import script from "./CustomDashboardOkrModule.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardOkrModule.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__